import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowheadRight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M7.554 6.106A1 1 0 0 1 8.6 6.2l4 3a1 1 0 0 1 0 1.6l-4 3A1 1 0 0 1 7 13V7a1 1 0 0 1 .553-.894Z",
		clipRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgArrowheadRight);
export { ForwardRef as ReactComponent };
